/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  AdminSchedulingLinkId,
  AppliedStyling,
  AssignedLicensesResponse,
  BulkInviteRequest,
  BulkInviteResponse,
  BulkSendInviteNotificationsRequest,
  BulkTeamReassignmentRequestByFilterV3,
  BulkUpdateUserIsSuperAdminRequestV2,
  BulkUpdateUserLicensesRequestByFilterV2,
  BulkUpdateUserRolesRequestByFilterV2,
  BulkUserUpdateRequestByFilterV3,
  BulkWorkspaceReassignmentRequestByFilterV2,
  CheckLicenseUpdateResponse,
  CreateWorkspaceRequest,
  ImageUploadRequest,
  ImageUrlResponse,
  ImageUrlResponseOptional,
  LicenseUsageResponse,
  MapString,
  MapUserIdPersonalDetails,
  MapUserIdString,
  OrgBrandingPutRequest,
  PaginatedResultUMTUser,
  PaginatedResultUserAggregate,
  PaginatedResultUserChange,
  PersonalDetails,
  PersonalPage,
  PersonalWorkspace,
  RecentWorkspaces,
  RequestLicenseRequest,
  RevisedOptionStyle,
  RevisedOrgBranding,
  RevisedWorkspaceBranding,
  SelectWorkspaceRequest,
  Style,
  Update1,
  UpdateExtensionDownloadStatusRequest,
  UpdateOnboardingStatusRequest,
  UpdateWorkspaceRequest,
  UserIntegrationsResponse,
  UserQueryFilterV2,
  UserUpdatesResponse,
  ValidateEmailsRequest,
  ValidateEmailsResponse,
  Workspace,
} from "./data-contracts";
import { ContentType, FullRequestParams, HttpClient, QueryParamsType, RequestParams } from "../http-client";

export class V3<SecurityDataType = unknown> {
  // See templates/api.ejs we need this in order to send as parameter to request call
  serviceName = "workspace";
  /**
   * @deprecated Internal use only.
   */
  httpClient: HttpClient<SecurityDataType>;

  constructor(config?: ConstructorParameters<typeof HttpClient<SecurityDataType>>[0]) {
    this.httpClient = new HttpClient(config);
  }

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  request = <T = any, E = any>(params: FullRequestParams): Promise<T> => {
    return this.httpClient.clientRequest<T, E>({ ...params, serviceName: this.serviceName });
  };

  /**
   * @deprecated Internal use only.
   * See src/http-client we need this so we can send service name to http-client so it knows
   * which service is calling it
   */
  getServicePath = <Q extends QueryParamsType>(path: string, query?: Q): string => {
    const servicePath = this.httpClient.clientGetPath({ path, serviceName: this.serviceName });

    if (!query) return servicePath;

    const queryParams = this.httpClient.encodeQueryParams(query);
    return `${servicePath}?${queryParams}`;
  };

  /**
   * @description find user assigned licenses v3
   *
   * @tags Admin User Table, User Management Table, User Authenticated, User, License, User Management Table, V3
   * @name FindUserAssignedLicensesV3
   * @request GET:/v3/tenant/{tenantId}/users/licenses-assigned/types
   * @secure
   */
  findUserAssignedLicensesV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      AssignedLicensesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses-assigned/types`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserAssignedLicensesV3 */
  findUserAssignedLicensesV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses-assigned/types`);

  /**
   * No description
   *
   * @tags Admin User Table, User Management Table, User Authenticated, User, License, User Management Table, V3
   * @name FindUserAssignedLicensesUsageV3
   * @request GET:/v3/tenant/{tenantId}/users/licenses-assigned/count
   * @secure
   */
  findUserAssignedLicensesUsageV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      LicenseUsageResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses-assigned/count`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserAssignedLicensesUsageV3 */
  findUserAssignedLicensesUsageV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses-assigned/count`);

  /**
   * @description get user recent workspaces v3
   *
   * @tags User Authenticated, User, Recent Workspaces, Admin User Table, User Management Table, UMT, V3
   * @name GetUserRecentWorkspacesV3
   * @request GET:/v3/tenant/{tenantId}/user/{userId}/workspaces/recent
   * @secure
   */
  getUserRecentWorkspacesV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      RecentWorkspaces,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserRecentWorkspacesV3 */
  getUserRecentWorkspacesV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`);

  /**
   * @description store user selected recent workspace v3
   *
   * @tags User Authenticated, User, Recent Workspaces, Admin User Table, User Management Table, UMT, V3
   * @name StoreUserSelectedRecentWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/user/{userId}/workspaces/recent
   * @secure
   */
  storeUserSelectedRecentWorkspaceV3 = (
    tenantId: string,
    userId: string,
    data: SelectWorkspaceRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      RecentWorkspaces,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for storeUserSelectedRecentWorkspaceV3 */
  storeUserSelectedRecentWorkspaceV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/workspaces/recent`);

  /**
   * @description export users as csv v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name ExportUsersAsCsvV3
   * @request POST:/v3/tenant/{tenantId}/users/csv
   * @secure
   */
  exportUsersAsCsvV3 = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/csv`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for exportUsersAsCsvV3 */
  exportUsersAsCsvV3PathGetter = (
    tenantId: string,
    query?: {
      /** There is a haproxy workaround to send all query params as headers. We use this so we can use file download api to load CSV files. If you need to update it: injectAccessTokenQueryParam function in api-client/plugin.ts. */
      access_token?: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/users/csv`, query);

  /**
   * @description Gets changelog of a user v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name GetUserChangelogV3
   * @request GET:/v3/tenant/{tenantId}/user-changelog
   * @secure
   */
  getUserChangelogV3 = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      userId?: string;
      callerRef?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserChange,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user-changelog`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUserChangelogV3 */
  getUserChangelogV3PathGetter = (
    tenantId: string,
    query?: {
      /** @pattern [^\s\\/]+ */
      userId?: string;
      callerRef?: string;
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/user-changelog`, query);

  /**
   * @description get used integrations v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name GetUsedIntegrationsV3
   * @request GET:/v3/tenant/{tenantId}/used-integrations
   * @secure
   */
  getUsedIntegrationsV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      UserIntegrationsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/used-integrations`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getUsedIntegrationsV3 */
  getUsedIntegrationsV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/used-integrations`);

  /**
   * @description find users by filter v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name FindUsersByFilterV3
   * @request POST:/v3/tenant/{tenantId}/users
   * @secure
   */
  findUsersByFilterV3 = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUserAggregate,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUsersByFilterV3 */
  findUsersByFilterV3PathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/users`, query);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name UpdateUserOnboardingStatusV3
   * @request POST:/v3/tenant/{tenantId}/user/{userId}/onboarding-status
   * @deprecated
   * @secure
   */
  updateUserOnboardingStatusV3 = (
    tenantId: string,
    userId: string,
    data: UpdateOnboardingStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/onboarding-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserOnboardingStatusV3 */
  updateUserOnboardingStatusV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/onboarding-status`);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name UpdateUserExtensionDownloadStatusV3
   * @request POST:/v3/tenant/{tenantId}/user/{userId}/extension-download-status
   * @deprecated
   * @secure
   */
  updateUserExtensionDownloadStatusV3 = (
    tenantId: string,
    userId: string,
    data: UpdateExtensionDownloadStatusRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/extension-download-status`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateUserExtensionDownloadStatusV3 */
  updateUserExtensionDownloadStatusV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/extension-download-status`);

  /**
   * @description remove users by filter v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name RemoveUsersByFilterV3
   * @request DELETE:/v3/tenant/{tenantId}/users/by-filter
   * @secure
   */
  removeUsersByFilterV3 = (tenantId: string, data: UserQueryFilterV2, params: RequestParams = {}) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/by-filter`,
      method: "DELETE",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for removeUsersByFilterV3 */
  removeUsersByFilterV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/users/by-filter`);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name BulkUpdateUsersByIdIsAdminV3
   * @request POST:/v3/tenant/{tenantId}/users/super-admin
   * @deprecated
   * @secure
   */
  bulkUpdateUsersByIdIsAdminV3 = (
    tenantId: string,
    data: BulkUpdateUserIsSuperAdminRequestV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/super-admin`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersByIdIsAdminV3 */
  bulkUpdateUsersByIdIsAdminV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/super-admin`);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name BulkUpdateUsersByFilterRolesV3
   * @request POST:/v3/tenant/{tenantId}/users/roles/by-filter
   * @deprecated
   * @secure
   */
  bulkUpdateUsersByFilterRolesV3 = (
    tenantId: string,
    data: BulkUpdateUserRolesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/roles/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersByFilterRolesV3 */
  bulkUpdateUsersByFilterRolesV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/roles/by-filter`);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name BulkUpdateUsersByFilterLicensesV3
   * @request POST:/v3/tenant/{tenantId}/users/licenses/by-filter
   * @deprecated
   * @secure
   */
  bulkUpdateUsersByFilterLicensesV3 = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersByFilterLicensesV3 */
  bulkUpdateUsersByFilterLicensesV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses/by-filter`);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name BulkUpdateUsersAssignedWorkspacesWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/users/workspaces/by-filter
   * @deprecated
   * @secure
   */
  bulkUpdateUsersAssignedWorkspacesWorkspaceV3 = (
    tenantId: string,
    data: BulkWorkspaceReassignmentRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/workspaces/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersAssignedWorkspacesWorkspaceV3 */
  bulkUpdateUsersAssignedWorkspacesWorkspaceV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/workspaces/by-filter`);

  /**
   * @description Deprecated - use bulk update users v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name BulkUpdateUsersAssignedTeamsV3
   * @request POST:/v3/tenant/{tenantId}/users/teams/by-filter
   * @deprecated
   * @secure
   */
  bulkUpdateUsersAssignedTeamsV3 = (
    tenantId: string,
    data: BulkTeamReassignmentRequestByFilterV3,
    params: RequestParams = {},
  ) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/teams/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersAssignedTeamsV3 */
  bulkUpdateUsersAssignedTeamsV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/teams/by-filter`);

  /**
   * @description check if bulk update users by filter licenses v3 is possible
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name CheckIfBulkUpdateUsersByFilterLicensesV3IsPossible
   * @request POST:/v3/tenant/{tenantId}/users/licenses/by-filter/check
   * @secure
   */
  checkIfBulkUpdateUsersByFilterLicensesV3IsPossible = (
    tenantId: string,
    data: BulkUpdateUserLicensesRequestByFilterV2,
    params: RequestParams = {},
  ) =>
    this.request<
      CheckLicenseUpdateResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses/by-filter/check`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for checkIfBulkUpdateUsersByFilterLicensesV3IsPossible */
  checkIfBulkUpdateUsersByFilterLicensesV3IsPossiblePathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses/by-filter/check`);

  /**
   * @description bulk update users assigned teams workspaces roles licenses v3
   *
   * @tags Admin User Table, User Management Table, UMT, User, User Authenticated, V3
   * @name BulkUpdateUsersV3
   * @request POST:/v3/tenant/{tenantId}/users/all/by-filter
   * @secure
   */
  bulkUpdateUsersV3 = (tenantId: string, data: BulkUserUpdateRequestByFilterV3, params: RequestParams = {}) =>
    this.request<
      UserUpdatesResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/all/by-filter`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkUpdateUsersV3 */
  bulkUpdateUsersV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/users/all/by-filter`);

  /**
   * @description Query UMT users by filters v3
   *
   * @tags Admin User Table, User Management Table, UMT, V3
   * @name FindUserManagementTableUsersV3
   * @request POST:/v3/tenant/{tenantId}/user-management-table/users/by-filter
   * @secure
   */
  findUserManagementTableUsersV3 = (
    tenantId: string,
    data: UserQueryFilterV2,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      PaginatedResultUMTUser,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user-management-table/users/by-filter`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findUserManagementTableUsersV3 */
  findUserManagementTableUsersV3PathGetter = (
    tenantId: string,
    query?: {
      /**
       * @format int64
       * @min 0
       * @default 0
       * @example 0
       */
      page?: number;
      /**
       * @format int64
       * @exclusiveMin 0
       * @default 10
       * @example 10
       */
      pageSize?: number;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/user-management-table/users/by-filter`, query);

  /**
   * @description create workspace v3
   *
   * @tags Workspaces, User Authenticated, V3
   * @name CreateWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/workspace
   * @secure
   */
  createWorkspaceV3 = (tenantId: string, data: CreateWorkspaceRequest, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for createWorkspaceV3 */
  createWorkspaceV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/workspace`);

  /**
   * @description find workspace by id v3
   *
   * @tags Workspaces, User Authenticated, V3
   * @name GetWorkspaceV3
   * @request GET:/v3/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  getWorkspaceV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspaceV3 */
  getWorkspaceV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description update workspace by id v3
   *
   * @tags Workspaces, User Authenticated, V3
   * @name UpdateWorkspaceV3
   * @request POST:/v3/tenant/{tenantId}/workspace/{workspaceId}
   * @secure
   */
  updateWorkspaceV3 = (
    tenantId: string,
    workspaceId: string,
    data: UpdateWorkspaceRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspaceV3 */
  updateWorkspaceV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}`);

  /**
   * @description find personal workspace by user id v3
   *
   * @tags Workspaces, User Authenticated, V3
   * @name GetWorkspacePersonalV3
   * @request GET:/v3/tenant/{tenantId}/workspace/personal/user/{userId}
   * @secure
   */
  getWorkspacePersonalV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/personal/user/${userId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspacePersonalV3 */
  getWorkspacePersonalV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/personal/user/${userId}`);

  /**
   * @description soft delete workspace by id v3
   *
   * @tags Workspaces, User Authenticated, V3
   * @name SoftDeleteWorkspaceV3
   * @request DELETE:/v3/tenant/{tenantId}/workspace/{workspaceId}/soft
   * @secure
   */
  softDeleteWorkspaceV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      Workspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/soft`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for softDeleteWorkspaceV3 */
  softDeleteWorkspaceV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/soft`);

  /**
   * @description guest get personal workspace by user id v3
   *
   * @tags Workspaces, Guest, V3
   * @name GuestGetPersonalWorkspaceV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/workspaces/personal
   * @secure
   */
  guestGetPersonalWorkspaceV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalWorkspace,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/workspaces/personal`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetPersonalWorkspaceV3 */
  guestGetPersonalWorkspaceV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/user/${userId}/workspaces/personal`);

  /**
   * @description validate emails v3
   *
   * @tags User Invites, User Authenticated, V3
   * @name ValidateEmailsV3
   * @request POST:/v3/tenant/{tenantId}/users/invites/validate-emails
   * @secure
   */
  validateEmailsV3 = (tenantId: string, data: ValidateEmailsRequest, params: RequestParams = {}) =>
    this.request<
      ValidateEmailsResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/invites/validate-emails`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for validateEmailsV3 */
  validateEmailsV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/invites/validate-emails`);

  /**
   * @description bulk invite users v3
   *
   * @tags User Invites, User Authenticated, V3
   * @name BulkInviteUsersV3
   * @request POST:/v3/tenant/{tenantId}/users/invites
   * @secure
   */
  bulkInviteUsersV3 = (tenantId: string, data: BulkInviteRequest, params: RequestParams = {}) =>
    this.request<
      BulkInviteResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/invites`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkInviteUsersV3 */
  bulkInviteUsersV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/users/invites`);

  /**
   * @description True when there are users to be invited. False when not. To be invited means never invited or invited before now - the configured cooldown. Omit the `users` array if you wish to list all from tenant; use it if you want to filter a predefined list v3
   *
   * @tags User Invites, User Authenticated, V3
   * @name UsersExistToBeInvitedV3
   * @request POST:/v3/tenant/{tenantId}/users/invites/existToBeInvited
   * @secure
   */
  usersExistToBeInvitedV3 = (tenantId: string, data: BulkSendInviteNotificationsRequest, params: RequestParams = {}) =>
    this.request<
      boolean,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/invites/existToBeInvited`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for usersExistToBeInvitedV3 */
  usersExistToBeInvitedV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/invites/existToBeInvited`);

  /**
   * @description Send invite notifications, omit the `users` array if you wish to notify all v3
   *
   * @tags User Invites, User Authenticated, V3
   * @name BulkSendInviteNotificationsV3
   * @request POST:/v3/tenant/{tenantId}/users/invites/notify
   * @secure
   */
  bulkSendInviteNotificationsV3 = (
    tenantId: string,
    data: BulkSendInviteNotificationsRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/invites/notify`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for bulkSendInviteNotificationsV3 */
  bulkSendInviteNotificationsV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/invites/notify`);

  /**
   * No description
   *
   * @tags User Invites, User Authenticated, V3
   * @name SendRequestLicenseNotificationV3
   * @request POST:/v3/tenant/{tenantId}/users/licenses/request
   * @secure
   */
  sendRequestLicenseNotificationV3 = (tenantId: string, data: RequestLicenseRequest, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/users/licenses/request`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for sendRequestLicenseNotificationV3 */
  sendRequestLicenseNotificationV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/users/licenses/request`);

  /**
   * @description Finds a user's personal details with First Name or Last Name or Email that contain the specified name (case-insensitive)
   *
   * @tags Personal Details, User Authenticated, V3
   * @name FindPersonalDetailsByNameV3
   * @request GET:/v3/tenant/{tenantId}/personal-details-by-name
   * @secure
   */
  findPersonalDetailsByNameV3 = (
    tenantId: string,
    query: {
      name: string;
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdPersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/personal-details-by-name`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for findPersonalDetailsByNameV3 */
  findPersonalDetailsByNameV3PathGetter = (
    tenantId: string,
    query: {
      name: string;
    },
  ) => this.getServicePath(`/v3/tenant/${tenantId}/personal-details-by-name`, query);

  /**
   * @description updates a user's personal details
   *
   * @tags Personal Details, User Authenticated, V3
   * @name SetPersonalDetailsV3
   * @request PUT:/v3/tenant/{tenantId}/user/{userId}/personal-details
   * @secure
   */
  setPersonalDetailsV3 = (tenantId: string, userId: string, data: PersonalDetails, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-details`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setPersonalDetailsV3 */
  setPersonalDetailsV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-details`);

  /**
   * @description set user picture v3
   *
   * @tags Personal Details, User Authenticated, V3
   * @name SetUserPictureV3
   * @request PUT:/v3/tenant/{tenantId}/user/{userId}/personal-details/image
   * @secure
   */
  setUserPictureV3 = (tenantId: string, userId: string, data: ImageUploadRequest, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for setUserPictureV3 */
  setUserPictureV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description delete user picture v3
   *
   * @tags Personal Details, User Authenticated, V3
   * @name DeleteUserPictureV3
   * @request DELETE:/v3/tenant/{tenantId}/user/{userId}/personal-details/image
   * @secure
   */
  deleteUserPictureV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteUserPictureV3 */
  deleteUserPictureV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description set custom company logo v3
   *
   * @tags Personal Details, User Authenticated, V3
   * @name SetCustomCompanyLogoForUserV3
   * @request PUT:/v3/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @secure
   */
  setCustomCompanyLogoForUserV3 = (
    tenantId: string,
    userId: string,
    data: ImageUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for setCustomCompanyLogoForUserV3 */
  setCustomCompanyLogoForUserV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description delete custom company logo for user v3
   *
   * @tags Personal Details, User Authenticated, V3
   * @name DeleteCustomCompanyLogoForUserV3
   * @request DELETE:/v3/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @secure
   */
  deleteCustomCompanyLogoForUserV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteCustomCompanyLogoForUserV3 */
  deleteCustomCompanyLogoForUserV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description Finds a user's personal details by the specified id - for guests
   *
   * @tags Personal Details, Guest, V3
   * @name GuestFindPersonalDetailsV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/personal-details
   * @secure
   */
  guestFindPersonalDetailsV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestFindPersonalDetailsV3 */
  guestFindPersonalDetailsV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details`);

  /**
   * @description Finds a user's personal details by the specified id - for guests
   *
   * @tags Personal Details, Guest, V3
   * @name GuestFindPersonalDetailsOfListOfUsersV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/personal-details-by-ids
   * @secure
   */
  guestFindPersonalDetailsOfListOfUsersV3 = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdPersonalDetails,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/personal-details-by-ids`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestFindPersonalDetailsOfListOfUsersV3 */
  guestFindPersonalDetailsOfListOfUsersV3PathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
  ) => this.getServicePath(`/v3/guest-external/tenant/${tenantId}/personal-details-by-ids`, query);

  /**
   * @description guest get picture of users v3
   *
   * @tags Personal Details, Guest, V3
   * @name GuestGetPictureOfUsersV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/images
   * @secure
   */
  guestGetPictureOfUsersV3 = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
    params: RequestParams = {},
  ) =>
    this.request<
      MapUserIdString,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/images`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetPictureOfUsersV3 */
  guestGetPictureOfUsersV3PathGetter = (
    tenantId: string,
    query?: {
      /** @minItems 1 */
      id?: string[];
    },
  ) => this.getServicePath(`/v3/guest-external/tenant/${tenantId}/images`, query);

  /**
   * @description guest get picture of user v3
   *
   * @tags Personal Details, Guest, V3
   * @name GuestGetPictureOfUserV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/personal-details/image
   * @secure
   */
  guestGetPictureOfUserV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details/image`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetPictureOfUserV3 */
  guestGetPictureOfUserV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details/image`);

  /**
   * @description guest get custom company logo for user v3
   *
   * @tags Personal Details, Guest, V3
   * @name GuestGetCustomCompanyLogoForUserV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo
   * @secure
   */
  guestGetCustomCompanyLogoForUserV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponse,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetCustomCompanyLogoForUserV3 */
  guestGetCustomCompanyLogoForUserV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo`);

  /**
   * @description guest get custom company logo for user v3
   *
   * @tags Personal Details, Guest, V3
   * @name GuestGetCustomCompanyLogoForUserV3Optional
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/personal-details/custom-company-logo-optional
   * @secure
   */
  guestGetCustomCompanyLogoForUserV3Optional = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      ImageUrlResponseOptional,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo-optional`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetCustomCompanyLogoForUserV3Optional */
  guestGetCustomCompanyLogoForUserV3OptionalPathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(
      `/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-details/custom-company-logo-optional`,
    );

  /**
   * @description set personal page v3
   *
   * @tags Personal Pages, User Authenticated, V3
   * @name SetPersonalPageV3
   * @request PUT:/v3/tenant/{tenantId}/user/{userId}/personal-page
   * @secure
   */
  setPersonalPageV3 = (tenantId: string, userId: string, data: Update1, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      ...params,
    });

  /**
   * @description Returns string containing request path for setPersonalPageV3 */
  setPersonalPageV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description Deactivates a personal page - for internal use will still be queryable
   *
   * @tags Personal Pages, User Authenticated, V3
   * @name DeletePersonalPageV3
   * @request DELETE:/v3/tenant/{tenantId}/user/{userId}/personal-page
   * @secure
   */
  deletePersonalPageV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deletePersonalPageV3 */
  deletePersonalPageV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description guest get personal page v3
   *
   * @tags Personal Pages, Guest, V3
   * @name GuestGetPersonalPageV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/user/{userId}/personal-page
   * @secure
   */
  guestGetPersonalPageV3 = (tenantId: string, userId: string, params: RequestParams = {}) =>
    this.request<
      PersonalPage,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-page`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetPersonalPageV3 */
  guestGetPersonalPageV3PathGetter = (tenantId: string, userId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/user/${userId}/personal-page`);

  /**
   * @description get org branding v3
   *
   * @tags Branding, Org Branding, User Authenticated, V3
   * @name GetOrgBrandingV3
   * @request GET:/v3/tenant/{tenantId}/branding
   * @secure
   */
  getOrgBrandingV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      RevisedOrgBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOrgBrandingV3 */
  getOrgBrandingV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/branding`);

  /**
   * @description update tenant branding v3
   *
   * @tags Branding, Org Branding, User Authenticated, V3
   * @name UpdateTenantBrandingV3
   * @request PUT:/v3/tenant/{tenantId}/branding
   * @secure
   */
  updateTenantBrandingV3 = (tenantId: string, data: OrgBrandingPutRequest, params: RequestParams = {}) =>
    this.request<
      RevisedOrgBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/branding`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateTenantBrandingV3 */
  updateTenantBrandingV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/branding`);

  /**
   * @description get org logo v3
   *
   * @tags Branding, Org Branding, User Authenticated, V3
   * @name GetOrgLogoV3
   * @request GET:/v3/tenant/{tenantId}/logo
   * @secure
   */
  getOrgLogoV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/logo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getOrgLogoV3 */
  getOrgLogoV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/logo`);

  /**
   * @description update org logo v3
   *
   * @tags Branding, Org Branding, User Authenticated, V3
   * @name UpdateOrgLogoV3
   * @request PUT:/v3/tenant/{tenantId}/logo
   * @secure
   */
  updateOrgLogoV3 = (tenantId: string, data: ImageUploadRequest, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/logo`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateOrgLogoV3 */
  updateOrgLogoV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/logo`);

  /**
   * @description delete org logo v3
   *
   * @tags Branding, Org Branding, User Authenticated, V3
   * @name DeleteOrgLogoV3
   * @request DELETE:/v3/tenant/{tenantId}/logo
   * @secure
   */
  deleteOrgLogoV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteOrgLogoV3 */
  deleteOrgLogoV3PathGetter = (tenantId: string) => this.getServicePath(`/v3/tenant/${tenantId}/logo`);

  /**
   * @description guest get org branding v3
   *
   * @tags Branding, Org Branding, Guest, V3
   * @name GuestGetOrgBrandingV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/branding
   * @secure
   */
  guestGetOrgBrandingV3 = (tenantId: string, params: RequestParams = {}) =>
    this.request<
      RevisedOrgBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetOrgBrandingV3 */
  guestGetOrgBrandingV3PathGetter = (tenantId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/branding`);

  /**
   * @description get workspace branding v3
   *
   * @tags Branding, Workspace Branding, User Authenticated, V3
   * @name GetWorkspaceBrandingV3
   * @request GET:/v3/tenant/{tenantId}/workspace/{workspaceId}/branding
   * @secure
   */
  getWorkspaceBrandingV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      RevisedWorkspaceBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspaceBrandingV3 */
  getWorkspaceBrandingV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/branding`);

  /**
   * @description get workspace logo v3
   *
   * @tags Branding, Workspace Branding, User Authenticated, V3
   * @name GetWorkspaceLogoV3
   * @request GET:/v3/tenant/{tenantId}/workspace/{workspaceId}/logo
   * @secure
   */
  getWorkspaceLogoV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/logo`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for getWorkspaceLogoV3 */
  getWorkspaceLogoV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/logo`);

  /**
   * @description update workspace logo v3
   *
   * @tags Branding, Workspace Branding, User Authenticated, V3
   * @name UpdateWorkspaceLogoV3
   * @request PUT:/v3/tenant/{tenantId}/workspace/{workspaceId}/logo
   * @secure
   */
  updateWorkspaceLogoV3 = (
    tenantId: string,
    workspaceId: string,
    data: ImageUploadRequest,
    params: RequestParams = {},
  ) =>
    this.request<
      AdminSchedulingLinkId,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/logo`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.FormData,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspaceLogoV3 */
  updateWorkspaceLogoV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/logo`);

  /**
   * @description delete workspace logo v3
   *
   * @tags Branding, Workspace Branding, User Authenticated, V3
   * @name DeleteWorkspaceLogoV3
   * @request DELETE:/v3/tenant/{tenantId}/workspace/{workspaceId}/logo
   * @secure
   */
  deleteWorkspaceLogoV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      void,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/logo`,
      method: "DELETE",
      secure: true,
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWorkspaceLogoV3 */
  deleteWorkspaceLogoV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/logo`);

  /**
   * @description update workspace style v3
   *
   * @tags Branding, Workspace Branding, User Authenticated, V3
   * @name UpdateWorkspaceStyleV3
   * @request PUT:/v3/tenant/{tenantId}/workspace/{workspaceId}/branding/style
   * @secure
   */
  updateWorkspaceStyleV3 = (tenantId: string, workspaceId: string, data: Style, params: RequestParams = {}) =>
    this.request<
      RevisedOptionStyle,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/branding/style`,
      method: "PUT",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for updateWorkspaceStyleV3 */
  updateWorkspaceStyleV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/branding/style`);

  /**
   * @description delete workspace branding v3
   *
   * @tags Branding, Workspace Branding, User Authenticated, V3
   * @name DeleteWorkspaceBrandingV3
   * @request DELETE:/v3/tenant/{tenantId}/workspace/{workspaceId}/branding/style
   * @secure
   */
  deleteWorkspaceBrandingV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      RevisedWorkspaceBranding,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/tenant/${tenantId}/workspace/${workspaceId}/branding/style`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for deleteWorkspaceBrandingV3 */
  deleteWorkspaceBrandingV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/tenant/${tenantId}/workspace/${workspaceId}/branding/style`);

  /**
   * @description returns actual css branding to be applied for a workspace, taking org and workspace level into consideration v3
   *
   * @tags Branding, Org Branding, Guest, V3, Workspace Branding, Applied Branding
   * @name GuestGetWorkspaceAppliedStylingV3
   * @request GET:/v3/guest-external/tenant/{tenantId}/workspace/{workspaceId}/applied-branding
   * @secure
   */
  guestGetWorkspaceAppliedStylingV3 = (tenantId: string, workspaceId: string, params: RequestParams = {}) =>
    this.request<
      AppliedStyling,
      | AdminSchedulingLinkId
      | {
          errorCode: string;
          errorMessage: string;
          arguments?: MapString;
          data?: any;
        }
    >({
      path: `/v3/guest-external/tenant/${tenantId}/workspace/${workspaceId}/applied-branding`,
      method: "GET",
      secure: true,
      format: "json",
      ...params,
    });

  /**
   * @description Returns string containing request path for guestGetWorkspaceAppliedStylingV3 */
  guestGetWorkspaceAppliedStylingV3PathGetter = (tenantId: string, workspaceId: string) =>
    this.getServicePath(`/v3/guest-external/tenant/${tenantId}/workspace/${workspaceId}/applied-branding`);
}
